import * as React from "react";
const SvgFiBrandsCreativeCommonsSa = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-creative-commons-sa_svg__a)">
      <path
        fill="#151A2D"
        d="M11.979 0q5.036 0 8.528 3.493Q23.999 6.964 24 12t-3.429 8.443Q16.95 24 11.979 24q-4.864 0-8.443-3.536Q0 16.929 0 12q0-4.907 3.536-8.507Q7.028 0 11.979 0m.042 2.164q-4.093 0-6.921 2.893Q2.164 8.036 2.164 12q0 4.007 2.914 6.9 2.914 2.914 6.943 2.914 4.007 0 6.986-2.936 2.829-2.742 2.829-6.879 0-4.114-2.871-6.943-2.851-2.891-6.944-2.892m-5.357 8.143Q7.006 8.1 8.443 6.889q1.435-1.21 3.493-1.211 2.829 0 4.5 1.821 1.671 1.822 1.671 4.671 0 2.764-1.736 4.597-1.735 1.832-4.5 1.832-2.036 0-3.514-1.222-1.479-1.221-1.779-3.471H9.6q.107 2.186 2.636 2.186 1.264 0 2.036-1.093t.772-2.914q0-1.907-.707-2.903-.707-.997-2.036-.997-2.4 0-2.7 2.121h.879l-2.38 2.38-2.378-2.379z"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-creative-commons-sa_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsCreativeCommonsSa;
